import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box } from '../../../base/Box/Box';
import Link from '../../../base/Link/Link';

import { TeamMemberStoryblok } from '../../../types/storyblok';
import { Type } from '../../../base/Type/Type';

const getTargetImage = ({ photo }: TeamMemberStoryblok) =>
  getImage(photo.images[photo.images.length - 1]);

const getTargetLink = ({ link }: TeamMemberStoryblok) => {
  const isLinkedinId = !link.startsWith('http');

  return isLinkedinId ? `https://www.linkedin.com/in/${link}` : link;
};

const TeamMemberCard = (props: TeamMemberStoryblok) => {
  const targetImage = getTargetImage(props);
  const targetLink = getTargetLink(props);

  return (
    <Link className="block" href={targetLink}>
      {targetImage && (
        <Box
          as="div"
          className="overflow-clip rounded-md h-[178px] sm:h-[218px] md:h-[318px] w-[151px] sm:w-[170px] md:w-[270px]"
        >
          <GatsbyImage
            image={targetImage}
            alt={props.name}
            className="transition-all delay-100 ease-in-out grayscale hover:grayscale-0 rounded-md"
          />
        </Box>
      )}
      <Box
        as="div"
        className="mt-4 max-w-[151px] sm:max-w-[170px] md:max-w-[270px]"
      >
        <Type
          as="h2"
          className="font-foundersGrotesk text-[18px] md:text-p1 !font-normal"
        >
          {props.name}
        </Type>

        <Type
          as="p"
          className="font-foundersGrotesk font-thin text-[16px] md:text-[18px]"
        >
          {props.description}
        </Type>
      </Box>
    </Link>
  );
};

export default TeamMemberCard;
